export default __webpack_public_path__ + "static/media/edc.8ed48869.png";